import { render } from "./ConfirmModalComponent.vue?vue&type=template&id=184a1550"
import script from "./ConfirmModalComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmModalComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__